var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaymentResultError = function SvgPaymentResultError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#payment-result-error_svg__a)",
    fill: "#E94F66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.18 49.962 30.1 24.883a2.798 2.798 0 0 0-3.959 0l-1.322 1.32a2.8 2.8 0 0 0 0 3.96L49.9 55.24a2.799 2.799 0 0 0 3.96 0l1.319-1.32a2.797 2.797 0 0 0 .002-3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.899 24.883 24.82 49.962a2.8 2.8 0 0 0 0 3.959l1.32 1.32a2.799 2.799 0 0 0 3.96 0l25.08-25.077a2.798 2.798 0 0 0 0-3.96l-1.32-1.319a2.799 2.799 0 0 0-3.961-.002Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "payment-result-error_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(24 24)",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgPaymentResultError;